import React, { useEffect, useState } from 'react';

import ReachPanel from './ReachPanel';
import type { OfflineModeDirection } from 'redux-stores/offlineMode';
import { reachDirectionFor } from 'redux-stores/offlineMode';
import { actions, thunk, useAppDispatch, useAppSelector } from 'redux-stores';

export const REACH_GATHERING_DEADLINE_MS = 6000;

export type ReachSummaryProps = {
  direction: OfflineModeDirection;
  organizationId: string;
};

export default function ReachSummary({ direction, organizationId }: ReachSummaryProps) {
  const dispatch = useAppDispatch();
  const { reach, reachStatus, reachDirection, reachError } = useAppSelector(
    (state) => state.offlineMode
  );

  const [deadlineElapsed, setDeadlineElapsed] = useState(false);

  const wireDirection = reachDirectionFor(direction);

  useEffect(() => {
    setDeadlineElapsed(false);
    thunk.fetchOfflineModeReach(dispatch, organizationId, wireDirection);
    return () => {
      dispatch(actions.clearOfflineModeReach());
    };
  }, [dispatch, organizationId, wireDirection]);

  const forThisDirection = reachDirection === wireDirection;
  const status = forThisDirection ? reachStatus : 'gathering';

  useEffect(() => {
    if (status !== 'gathering') return undefined;
    const timer = setTimeout(() => setDeadlineElapsed(true), REACH_GATHERING_DEADLINE_MS);
    return () => clearTimeout(timer);
  }, [status]);

  return (
    <ReachPanel
      deadlineElapsed={deadlineElapsed}
      direction={direction}
      error={forThisDirection ? reachError : null}
      reach={forThisDirection && reach?.direction === wireDirection ? reach : null}
      status={status}
    />
  );
}
